import { logAnalyticsEvent, refreshAnalyticsUserProperties } from '@/assets/js/firebase'

/** 投放链接专用 query key（installChannel 缩写，勿与 entry 等页面参数混用） */
export const INSTALL_CHANNEL_QUERY_KEY = 'isc'

const STORAGE_KEY = 'attribution.install_channel'
const SOURCE_KEY = 'attribution.install_source'
const DEFAULT_INSTALL_CHANNEL = 'webtest'

export const INSTALL_CHANNEL_HEADER = 'X-Install-Channel'
export const INSTALL_CHANNEL_ANALYTICS_KEY = 'install_channel'

export const INSTALL_CHANNEL = {
  ORGANIC: 'organic',
  WEBTEST: DEFAULT_INSTALL_CHANNEL,
  FACEBOOK: 'facebook',
  GOOGLE: 'google',
  TIKTOK: 'tiktok'
}

const PAID_INSTALL_CHANNELS = new Set([
  INSTALL_CHANNEL.FACEBOOK,
  INSTALL_CHANNEL.GOOGLE,
  INSTALL_CHANNEL.TIKTOK
])

const BASELINE_INSTALL_CHANNELS = new Set([
  INSTALL_CHANNEL.ORGANIC,
  INSTALL_CHANNEL.WEBTEST
])

const ALLOWED_URL_INSTALL_CHANNELS = PAID_INSTALL_CHANNELS

function normalizeInstallChannel (value) {
  const channel = String(value || '').trim().toLowerCase()
  if (!channel) return ''
  return channel.replace(/[^a-z0-9_-]/g, '_').slice(0, 64)
}

function readStorage (key) {
  try {
    return localStorage.getItem(key) || ''
  } catch {
    return ''
  }
}

function writeStorage (key, value) {
  try {
    localStorage.setItem(key, value)
  } catch {
    // Storage may be unavailable in private mode or restricted WebViews.
  }
}

export function isInstallChannelSet () {
  return readStorage(STORAGE_KEY).length > 0
}

export function getInstallChannel () {
  const channel = normalizeInstallChannel(readStorage(STORAGE_KEY))
  return channel || DEFAULT_INSTALL_CHANNEL
}

export function getInstallChannelSource () {
  return readStorage(SOURCE_KEY) || ''
}

function readInstallChannelFromQuery () {
  if (typeof window === 'undefined') return ''

  const params = new URLSearchParams(window.location.search)
  const normalized = normalizeInstallChannel(params.get(INSTALL_CHANNEL_QUERY_KEY))
  if (!normalized || !ALLOWED_URL_INSTALL_CHANNELS.has(normalized)) return ''
  return normalized
}

function reportInstallChannelChange ({ channel, source, previousChannel }) {
  logAnalyticsEvent('install_attribution', {
    [INSTALL_CHANNEL_ANALYTICS_KEY]: channel,
    attribution_source: source,
    previous_install_channel: previousChannel || ''
  })
  refreshAnalyticsUserProperties()
}

function saveInstallChannel (channel, source) {
  const normalized = normalizeInstallChannel(channel)
  if (!normalized) return

  const previousChannel = getInstallChannel()
  if (previousChannel === normalized) return

  // 一旦是买量，永远不允许被降回 organic / webtest。
  if (BASELINE_INSTALL_CHANNELS.has(normalized) &&
    previousChannel && !BASELINE_INSTALL_CHANNELS.has(previousChannel)) {
    return
  }

  writeStorage(STORAGE_KEY, normalized)
  if (source) writeStorage(SOURCE_KEY, source)
  reportInstallChannelChange({ channel: normalized, source, previousChannel })

  if (PAID_INSTALL_CHANNELS.has(normalized)) {
    window.dispatchEvent(new CustomEvent('install-attribution-changed', { detail: { channel: normalized } }))
  }
}

export function initInstallChannel () {
  const channelFromQuery = readInstallChannelFromQuery()
  if (channelFromQuery) {
    saveInstallChannel(channelFromQuery, 'url')
    return
  }

  if (!isInstallChannelSet()) {
    saveInstallChannel(DEFAULT_INSTALL_CHANNEL, 'default')
  }
}
